module.exports = "/assets/eca7baebb577c6cc405e9371cd20b383.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/amadeus-icon.png
// module id = 604
// module chunks = 0